import { cloneDeep } from 'lodash'
import { BuilderGptActions} from './types'
import { getInstanceWithToken } from '@/utils/axios'
  import { uploadMediaObject } from '@/services/media'
const actions: BuilderGptActions = {
    saveData({commit,state}, data) {
        const step = state.currentStep
        switch (step) {
            case 1:
                commit('setAppColor', data)
            break
            case 2:
                commit('setAppName', data)
                commit('setAppCurrency', data)
              
            break
            case 3:
                commit('setAppEmptyChatLogo', data)
                commit('setAppAvatarBlob', data)
                commit('setAppEmptyChatMessage', data)
            break
            case 4:
                commit('setTariffs', data)
                commit('setPromotionalPage', data)
            break
            case 5:
                commit('setAppBotLimits', data)
            break
            case 6:
                commit('setAppName', data)
                commit('setAppEmail', data)
                commit('setAppTelegram', data)
            break
        
            default:
            break
        }

        if(step <= 5) {
            commit('confirmStep')
            commit('changeStep', step + 1)
        }
        // commit('saveToLocalStorage')
    },

    async sendRegisterReuestData({state}) {
        try{
        const response = await getInstanceWithToken().post('/api/registration_requests', {
            email: state.app.email,
            telegram: state.app.telegram,
        })
            return{status: true, data: response} 
        }
        catch(error){
            return {status: false, error}
        
        }
     
    },
    async pushData({commit,state, rootGetters}) {
        // TODO: refactor this
        try {
            const { app } = state
            const currencyId = rootGetters['currency/getCurrency'].items.find(item => item.code === app.currency).id
            let app_result
            let tariffs_result
            let promotionalPage_result
            if(app.emptyChatLogo && typeof app.emptyChatLogo !== 'string'){
                const{ id } = await uploadMediaObject(app.emptyChatLogo)
                state.app.emptyChatLogo = `/api/media_objects/${id}`
            }
            // Create or update app
            if(!app.id) {
           
                app_result = await getInstanceWithToken().post('/api/apps', {
                    name: app.name,
                    primary_color: app.primaryColor,
                    botLimit: app.botLimit,
                    botLimitType: app.botLimitType,
                    image: app.emptyChatLogo,
                    emptyBotChatLogo: app.emptyChatLogo,
                    emptyBotChatMessage: app.emptyChatMessage,
                    prompts: app.prompts,
                    currency: `/api/currencies/${currencyId}`,
                    lang: 'ru',
                    type: "chat_gpt",
                })
                commit('setAppId', {id: app_result.data.id})
                commit('saveToLocalStorage')
            } else {
                app_result = await getInstanceWithToken().put(`/api/apps/${app.id}`, {
                    primary_color: app.primaryColor,
                    botLimit: app.botLimit,
                    botLimitType: app.botLimitType,
                    emptyBotChatLogo: app.emptyChatLogo,
                    emptyBotChatMessage: app.emptyChatMessage,
                    prompts: app.prompts,
                })
            }

            
            // Create or update tariffs
            let i = 0
        
    
            for (const tariff of app.tariffs) {
                let tariff_result
                const trialAmount=()=>{
                    if(state.app.currency === 'RUB'){
                       return tariff.frequency === 2 ? 1 : null
                    }
                    if(state.app.currency === 'USD'){
                        return 0
                    }
                }
                const trialPeriod=()=>{
                    if(state.app.currency === 'RUB'){
                       return tariff.frequency === 2 ? 7 : null
                    }
                    if(state.app.currency === 'USD'){
                        return 7
                    }
                }
                if(!tariff.id) {
                    tariff_result = await getInstanceWithToken().post('/api/tariffs', {
                        app: `/api/apps/${app.id}`,
                        type: 1,
                        name: `t-${tariff.name}`,
                        amount: String(tariff.price),
                        period: tariff.frequency,
                        duration:tariff.duration,
                        trial_amount: trialAmount(),
                        trial_period: trialPeriod(),
                    })
                } else {
                    tariff_result = await getInstanceWithToken().put(`/api/tariffs/${tariff.id}`, {
                        name: `t-${tariff.name}`,
                        amount: String(tariff.price),
                        period: tariff.frequency,
                        type: tariff.type,
                        duration:tariff.duration,
                        trial_amount: trialAmount(),
                        trial_period: trialPeriod(),
                    })
                }
                if(tariff_result?.data.id) {
                    commit('setTariffId', {id: tariff_result.data.id, index: i})
                    commit('saveToLocalStorage')
                }
                i++
            }


            // Create or update promotional page
            if(!app.promotionalPage.id) {
              
                promotionalPage_result = await getInstanceWithToken().post('/api/promotional_pages', {
                    app: `api/apps/${state.app.id}`,
                    status: 1,
                    designType: 1,
                    tariffs: state.app.tariffs.map(tariff => `/api/tariffs/${tariff.id}`),
                    name: state.app.promotionalPage.name,
                })
                commit('setPromotionalPageId', {id: promotionalPage_result.data.id})
                commit('saveToLocalStorage')
                
            } else {
                promotionalPage_result = await getInstanceWithToken().put(`/api/promotional_pages/${state.app.promotionalPage.id}`, {
                    app: `api/apps/${state.app.id}`,
                    status: 1,
                    designType: 1,
                    tariffs: state.app.tariffs.map(tariff => `/api/tariffs/${tariff.id}`),
                    name: state.app.promotionalPage.name,
                })
            }
            commit('clearLocalStorage')
            return true
            
        } catch (error: any) {
            console.error(error)
            return error
        }
    }

    
}
export default actions
